import {
    Component,
    EventEmitter,
    Input,
    Output,
    inject
} from '@angular/core';

import { MatButtonModule } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

import {
    BarcodeManagerService,
    EnvironmentInfoService
} from 'src/app/core';

@Component({
	standalone: true,
    selector: 'app-barcode-scanner',
    templateUrl: './barcode-scanner.component.html',
    styleUrls: ['./barcode-scanner.component.scss'],
    imports: [
        MatButtonModule,
        MatIcon
    ]
})
export class BarcodeScannerComponent {
    private readonly environmentInfoService = inject(EnvironmentInfoService);
    private readonly barcodeManagerService = inject(BarcodeManagerService);

    @Input() onBarcodeScanned?: string;
    @Input() topbarMode = false;
    @Output() onBarcodeScannedChange = new EventEmitter<string>();
    @Output() topBarModeChange = new EventEmitter();
    mode: 'topbar' | 'normal' = 'normal';
    canUseCameraBarcode = this.environmentInfoService.isCameraBarcodeSupported();

    constructor() {
    }

    ngOnInit(): void {
        this.mode = this.topbarMode ? 'topbar' : 'normal';
    }

    async openCameraBarcode() {
        const barcodeResult = await this.barcodeManagerService.openCameraBarcode();
        this.onBarcodeScannedChange.emit(barcodeResult);
    };

}
